import { Component, OnInit } from '@angular/core';
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from 'src/config/app.config';
import { FormGroup, FormControl } from '@angular/forms';
import { PolicyStatus } from '../core/policyStatus.model';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { SortEvent, SortDirection } from '@allianz/ng-aquila/table';
import { NxMessageToastService } from "@allianz/ng-aquila/message";

@Component({
  selector: 'app-workshopreport',
  templateUrl: './workshopreport.component.html',
  styleUrls: ['./workshopreport.component.css'],
  standalone: false
})

export class WorkshopreportComponent implements OnInit {
  /**Private variables */
  _apiUrl: string;

  userId: number;
  clientId: number;
  Models: any;
  workshopReportForm: FormGroup;
  policyStatus: any;
  exportdata: any = [];
  policyList: any;
  policyExcelList: any;
  reportType: string;
  policyTypeList = [];
  fileName: string = "WorkshopPolicySaleReport_" + new Date(Date.now()).toLocaleString().split(',')[0] + '.xlsx';

  /**Pagination Start */
  count: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;

  prevPage() {
    this.pageNumber--;
    this.getWorkShopReport(this.reportType);
  }

  nextPage() {
    this.pageNumber++;
    this.getWorkShopReport(this.reportType);
  }

  goToPage(n: number) {
    this.pageNumber = n;
    this.getWorkShopReport(this.reportType);
  }
  /**Pagination end */

  /** sorting starts here */

  sortTable(sort: SortEvent) {//Sorts the table data by a certain category.
    this.policyList = this.policyList.sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        return this.compare(a[sort.active], b[sort.active], sort.direction);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection) {

    return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }
  /** sorting ends here */

  constructor(private authService: AuthService, private appConfig: AppConfig, private messageToastService: NxMessageToastService) {
    this._apiUrl = appConfig.baseUrl;
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.getModelsList();
    this.policyStatus = PolicyStatus;
  }

  ngOnInit() {
    this.workshopReportFormBuilder();
    this.populatePolicyType();
  }

  workshopReportFormBuilder() {
    this.workshopReportForm = new FormGroup({
      startDatepicker: new FormControl(null),
      endDatepicker: new FormControl(null),
      policyNo: new FormControl(null),
      policyType: new FormControl(new Array<number>()),
      VehicleAge: new FormControl(-1),
      model: new FormControl(null),
      ClientId: new FormControl(this.clientId),
      WorkshopId: new FormControl(null),
    });
  }

  OnChangeReportType(value: string) {
    this.reportType = value;
  }

  getModelsList() {
    this.authService.get(this._apiUrl + '/api/v1/Models').subscribe(response => {
      if (response) {
        this.Models = response;
      }
    }, (error) => {

    });
  }

  getWorkShopReport(type: any) {
    if (type === undefined)
      this.messageToastService.open("Please select a report type !", { context: "info", duration: 5000 });
    else if (type == "policysales") {
      this.SearchPolicies();
    }
  }

  SearchPolicies(pagecount: number = 0) {
    this.workshopReportForm.value.startDatepicker != null ? this.workshopReportForm.patchValue({ "startDatepicker": this.workshopReportForm.value.startDatepicker }) : null;
    this.workshopReportForm.value.endDatepicker != null ? this.workshopReportForm.patchValue({ "endDatepicker": this.workshopReportForm.value.endDatepicker }) : null;
    this.authService.PostList(this._apiUrl + `/api/v1/Report/GetPolicySalesReport?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}`, this.workshopReportForm.value)
      .subscribe(response => {
        if (response) {
          var pagingProp = JSON.parse(response.headers.get('X-Pagination'));
          this.count = pagingProp.TotalCount;
          this.policyList = response.body;
        }
      }, (error) => {

      });
  }

  reset() {
    this.workshopReportFormBuilder();
    this.getWorkShopReport(this.reportType);
  }

  exporttoexcel(): void {
    this.workshopReportForm.value.startDatepicker != null ? this.workshopReportForm.patchValue({ "startDatepicker": this.workshopReportForm.value.startDatepicker }) : null;
    this.workshopReportForm.value.endDatepicker != null ? this.workshopReportForm.patchValue({ "endDatepicker": this.workshopReportForm.value.endDatepicker }) : null;
    this.authService.PostList(this._apiUrl + `/api/v1/Report/GetPolicySalesExcelReport`, this.workshopReportForm.value)
      .subscribe(response => {
        if (response) {
          this.policyExcelList = response.body;
          /* json data is passed over here */
          var workbook = new ExcelJS.Workbook();
          var worksheet = workbook.addWorksheet('WorkshopReport');
          worksheet = this.constructHeaderForExportExcel(worksheet);
          worksheet = this.setExportDataForExportExcel(this.policyExcelList, worksheet);
          this.saveAsExcelFile(workbook, this.fileName);
        }
      }, (error) => {

      });
  }

  constructHeaderForExportExcel(ws: any): any {
    ws.columns = [
      { key: 'SINo', header: 'SI NO', width: '20' },
      { key: 'DealerORWorkshopCode', header: 'Dealer/Worshop Code', width: '25' },
      { key: 'DealerORWorkshopName', header: 'Dealer/Worshop Name', width: '15' },
      { key: 'Asm_Name', header: 'ASM', width: '25' },
      { key: 'Rsm_Name', header: 'RSM', width: '15' },
      { key: 'policyNo', header: 'Policy NO', width: '25' },
      { key: 'vinChassisNo', header: 'VIN NO', width: '20' },
      { key: 'LicensePlateNO', header: 'License Plate NO"', width: '20' },
      { key: 'model', header: 'Model', width: '20' },
      { key: 'effectiveDate', header: 'Policy Start Date', width: '20' },
      { key: 'expiryDate', header: 'Policy End Date', width: '20' },
      { key: 'policyStatus', header: 'Policy Status', width: '20' },
      { key: 'Zone', header: 'Zone', width: '25' },
      { key: 'unitPrice', header: 'Price', width: '15' },
      { key: 'customerName', header: 'Customer Name', width: '20' },
      { key: 'MobileNumber', header: 'Customer Mobile No', width: '20' },
    ];
    return ws;
  }

  setExportDataForExportExcel(json: any, ws: any) {
    var status = '';
    json.forEach(function (item, index) {
      if (item.policyDetails.policyStatusId == PolicyStatus.Active) {
        status = "Active"
      }
      else if (item.policyDetails.policyStatusId == PolicyStatus.Cancel) {
        status = "Cancel"
      }
      else if (item.policyDetails.policyStatusId == PolicyStatus.Modified) {
        status = "Modified"
      }
      else if (item.policyDetails.policyStatusId == PolicyStatus.CancelationApprovalPending) {
        status = "Cancelation Approval Pending"
      }
      else if (item.policyDetails.policyStatusId == PolicyStatus.ModificationApprovalPending) {
        status = "Modification Approval Pending"
      }
      var row = ws.addRow({
        SINo: item.policyDetails.id,
        DealerORWorkshopCode: item.workshopCode == null ? item.dealerCode : item.workshopCode,
        DealerORWorkshopName: item.name,
        Asm_Name: item.asmName,
        Rsm_Name: item.rsmName,
        policyNo: item.policyDetails.policyNo,
        vinChassisNo: item.policyDetails.vinChassisNo,
        LicensePlateNO: item.policyDetails.licensePlateNo,
        model: item.policyDetails.model,
        effectiveDate: item.policyDetails.effectiveDate,
        expiryDate: item.policyDetails.expiryDate,
        policyStatus: status,
        Zone: item.zonename,
        unitPrice: item.policyDetails.unitPrice,
        customerName: item.policyDetails.customerFirstName + " " + item.policyDetails.customerLastName,
        MobileNumber: item.policyDetails.customerMobileNo,
      });
      //Border for each row
      row.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  }

  saveAsExcelFile(wb: any, fileName: string): void {
    wb.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var a = window.document.createElement('a');
      var downloadUrl = window.URL.createObjectURL(blob);
      a.href = downloadUrl;
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    });
  }

  populatePolicyType() {
    this.policyTypeList = [
      {
        policyStatus: 'Active',
        policyType: 'Issued Policy',
      },
      {
        policyStatus: 'Cancel',
        policyType: 'Cancelled Policy',
      },
      {
        policyStatus: 'Modified',
        policyType: 'Modified Policy',
      },
    ];
  }
}


